import { apiClient } from './apiClient';
import { API_ENDPOINTS } from '../constants';

export interface AuthorizeUrlResponse {
  url: string;
  state: string;
}

export interface MetaConnectedAppRow {
  id: string;
  pageId: string;
  pageName: string | null;
  metaUserId: string;
  platformUserId: string;
  webhookSubscribed: boolean;
  subscribedAt: string | null;
  subscribedFields: string | null;
  lastSubscribeError: string | null;
  /** Instagram Business Account id when the Facebook Page has IG linked. */
  instagramBusinessAccountId: string | null;
  instagramUsername: string | null;
  createdAt: string;
  updatedAt: string;
}

export const socialTestService = {
  async getMetaAuthorizeUrl(): Promise<AuthorizeUrlResponse> {
    const redirectUrl = `${window.location.origin}/settings`;
    const url = `${API_ENDPOINTS.SOCIAL.META_AUTH_URL}?redirect_url=${encodeURIComponent(redirectUrl)}`;
    return apiClient.get<AuthorizeUrlResponse>(url, {
      authenticate: true,
    });
  },

  async listMetaConnectedApps(): Promise<{ connectedApps: MetaConnectedAppRow[] }> {
    return apiClient.get<{ connectedApps: MetaConnectedAppRow[] }>(
      API_ENDPOINTS.SOCIAL.META_CONNECTED_APPS,
      { authenticate: true }
    );
  },
};
